import { createFileRoute } from "@tanstack/react-router";
import { AccountScreen } from "@modules/account-settings/views";

export const Route = createFileRoute("/_staff-area/account")({
  staticData: { title: "nav.account" },
  component: AccountScreen,
});
